import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import CrmLogin from "@/pages/CrmLogin";
import CrmDashboard from "@/pages/CrmDashboard";
import ApplicantLogin from "@/pages/ApplicantLogin";
import ApplicantDashboard from "@/pages/ApplicantDashboard";
import StudentLogin from "@/pages/StudentLogin";
import StudentDashboard from "@/pages/StudentDashboard";
import AuthCallback from "@/pages/AuthCallback";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import IzzyWidget from "@/components/IzzyWidget";
import ContactForm from "@/components/ContactForm";
import BackButton from "@/components/BackButton";
import { AppProvider } from "@/store/AppContext";
import "@/index.css";

function App() {
  useEffect(() => {
    document.title = "NextShore Immigration — Connecting people to their future";
  }, []);

  return (
    <AppProvider>
      <BrowserRouter>
        <BackButton />
        <Routes>
          <Route path="/" element={<><Home /><IzzyWidget /><ContactForm /></>} />
          <Route path="/crm/login" element={<CrmLogin />} />
          <Route path="/crm" element={<CrmDashboard />} />
          <Route path="/applicant/login" element={<ApplicantLogin />} />
          <Route path="/applicant" element={<ApplicantDashboard />} />
          <Route path="/student/login" element={<StudentLogin />} />
          <Route path="/student" element={<StudentDashboard />} />
          <Route path="/auth/callback" element={<AuthCallback />} />
          <Route path="/blog" element={<><BlogIndex /><ContactForm /></>} />
          <Route path="/blog/:slug" element={<><BlogPost /><ContactForm /></>} />
        </Routes>
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
